import Vue from 'vue'
import store from '@/store'
import Router from 'vue-router'
import Layout from './views/Layout.vue'
import Login from './views/Login.vue'
import { rtdb, auth } from '@/plugins/firebase'

// import Dashboard from './views/Dashboard.vue'
// import Assistance from './views/Assistance.vue'
// import Contact from './views/Contact.vue'
// import Calculators from './views/Calculators.vue'
// import ClientPath from './views/ClientPath.vue'
// import Feedback from './views/Feedback.vue'
// import Suggestions from './views/Suggestions.vue'
// import UserProfile from './views/UserProfile.vue'

// import AdminCalcs from './views/AdminCalcs.vue'
// import AdminInvoicing from './views/AdminInvoicing.vue'
// import AdminAssistance from './views/AdminAssistance.vue'
// import AdminMessaging from './views/AdminMessaging.vue'
// import AdminClientPath from './views/AdminClientPath.vue'
// import AdminLogs from './views/AdminLogs.vue'

// import AdminCalcsSetup from './views/AdminCalcsSetup.vue'
// import AdminCalcsFields from './views/AdminCalcsFields.vue'
// import AdminCalcsForms from './views/AdminCalcsForms.vue'
// import AdminCalcsReport from './views/AdminCalcsReport.vue'
// import AdminCalcsTest from './views/AdminCalcsTest.vue'
// import AdminCalcsWiki from './views/AdminCalcsWiki.vue'
// import AdminCalcsNotes from './views/AdminCalcsNotes.vue'








Vue.use(Router)

var requireAuth = (to, from, next) => {
  var authCheck = auth.onAuthStateChanged((user) => {

    if (!user) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else if (user.isAnonymous) {
      // if (user.isAnonymous) {
      next({
        path: '/logout',
        query: { redirect: to.fullPath }
      })
    } else {
      store.commit('set_user', user)
      rtdb.ref(`users/console`).on('value', s => {
        store.commit('set_users', s.val())
      })
      next()
    }
    authCheck()
  })
}

export default new Router({
  mode: 'history',
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    // {
    //   path: '/',
    //   component: Home,
    //   beforeEnter: requireAuth,
    //   meta: { consoleAppBar: true, isConsole: true },
    //   children: [
    //     { path: '/dashboard', component: Dashboard },
    //     { path: '/assistance/:sub?/:id?', component: Assistance },
    //     { path: '/contact/:sub?/:id?', component: Contact },
    //     { path: '/calculations/:sub?/:id?', component: Calculators },
    //     { path: '/clientpath/:sub?/:id?', component: ClientPath },
    //     { path: '/feedback/:sub?/:id?', component: Feedback },
    //     { path: '/suggestions/:sub?/:id?', component: Suggestions },
    //     { path: '/user/:sub?/:id?', component: UserProfile },

    //     { 
    //       path: '/admin/calculators/:sub?/:id?', 
    //       component: AdminCalcs,
    //       children: [
    //         { path: '/admin/calculators/:sub/setup/:id?', component: AdminCalcsSetup },
    //         { path: '/admin/calculators/:sub/fields/:id?', component: AdminCalcsFields },
    //         { path: '/admin/calculators/:sub/forms/:id?', component: AdminCalcsForms },
    //         { path: '/admin/calculators/:sub/report/:id?', component: AdminCalcsReport },
    //         { path: '/admin/calculators/:sub/test/:id?', component: AdminCalcsTest },
    //         { path: '/admin/calculators/:sub/wiki/:id?', component: AdminCalcsWiki },
    //         { path: '/admin/calculators/:sub/notes/:id?', component: AdminCalcsNotes },
    //       ]
    //     },
    //     { path: '/admin/invoicing/:sub?/:id?', component: AdminInvoicing },
    //     { path: '/admin/assistance/:sub?/:id?', component: AdminAssistance },
    //     { path: '/admin/messaging/:sub?/:id?', component: AdminMessaging },
    //     { path: '/admin/clientpath/:sub?/:id?', component: AdminClientPath },
    //     { path: '/admin/logs/:sub?/:id?', component: AdminLogs }
    //   ]
    // },
    {
      path: '/admin/:page?/:sub?/:id?',
      name: 'admin',
      component: Layout,
      beforeEnter: requireAuth,
      meta: { consoleAppBar: true, isConsole: true }
    },
    {
      path: '/:page?/:sub?/:id?',
      name: 'console',
      component: Layout,
      beforeEnter: requireAuth,
      meta: { consoleAppBar: true, isConsole: true }
    },
    {
      path: '/logout',
      name: 'app_logout',
      beforeEnter: (to, from, next) => {
        auth.signOut().then(() => {
          next({ path: '/login', query: { redirect: to.query.recdirect } })
        })
      }
    }
  ]
})
